import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { label: 'ABOUT US', id: 'about' },
  { label: 'OUR SERVICES', id: 'services' },
  { label: 'OUR PRODUCTS', id: 'products' },
  { label: 'CONTACT US', id: 'contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      // Find the hero section height — navbar only turns white AFTER the hero is fully scrolled past
      const heroSection = document.getElementById('hero-section');
      const threshold = heroSection
        ? heroSection.offsetTop + heroSection.offsetHeight - window.innerHeight
        : window.innerHeight * 5;
      setScrolled(window.scrollY > threshold);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-gray-100' : 'bg-transparent'
      }`}
    >
      <div className="px-8 md:px-16 py-4 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="cursor-pointer flex items-center gap-3"
        >
          <div className="relative w-10 h-10 flex items-center justify-center flex-shrink-0">
            <div className="absolute inset-0 bg-[#FFD93D] rounded-xl rotate-3" />
            <div className="absolute inset-0 bg-black rounded-xl -rotate-1" />
            <span
              className="relative z-10 font-black text-[#FFD93D]"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '18px', letterSpacing: '-0.05em' }}
            >RD</span>
          </div>
          <div className="flex flex-col leading-none">
            <span
              className={`font-black uppercase tracking-tight ${scrolled ? 'text-gray-900' : 'text-white'}`}
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.08em' }}
            >REGENT</span>
            <span
              className="text-[#FFD93D] font-black uppercase"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.08em' }}
            >DIGITAL</span>
          </div>
        </button>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`font-black uppercase tracking-widest transition-colors cursor-pointer whitespace-nowrap hover:text-[#FFD93D] ${
                scrolled ? 'text-gray-600' : 'text-white/80'
              }`}
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '16px' }}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('contact')}
            className="bg-[#FFD93D] text-black font-black uppercase px-6 py-2 rounded-full hover:bg-[#FF8C42] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '16px' }}
          >
            GET IN TOUCH
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} ${scrolled ? 'text-gray-900' : 'text-white'} text-3xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#1A1A1A] border-t border-white/10 px-8 py-6 flex flex-col gap-4">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white font-black uppercase text-2xl text-left hover:text-[#FFD93D] transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('contact')}
            className="bg-[#FFD93D] text-black font-black uppercase text-2xl text-left px-4 py-2 rounded-lg hover:bg-[#FF8C42] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Bebas Neue', sans-serif" }}
          >
            GET IN TOUCH
          </button>
        </div>
      )}
    </nav>
  );
}
